import { DiscountId } from 'types';

export const DISCOUNTS = 'api/v2/discounts';

export const DISCOUNT = (discountId: DiscountId) => `api/v2/discounts/${discountId}`;
